import styled from 'styled-components';

import search from '~/assets/icons/search.svg';

const StyledInput = styled.input`
	width: 100%;
	padding: 12px 54px 12px 20px;
	border-radius: 10px;
	background-color: rgba(255, 255, 255, 0.1);
	border: 0;

	color: #ffffff;
	font-family: GT Walsheim Pro;
	font-size: 14px;
	font-style: normal;
	font-weight: 400;
	line-height: normal;

	transition: all 0.3s ease;

	&::placeholder {
		color: rgba(255, 255, 255, 0.5);
		user-select: none;
	}

	&:focus {
		outline: none;
	}
`;

const StyledImage = styled.img.attrs({ src: search, width: 14, height: 14 })`
	position: absolute;
	top: 50%;
	right: 20px;
	transform: translateY(-50%);
	opacity: 0.25;
	transition: all 0.3s ease;
	user-select: none;
	pointer-events: none;
`;

const StyledContainer = styled.div`
	position: relative;
	width: 100%;

	&:hover {
		${StyledInput} {
			background-color: #ffffff;
			color: #000000;

			&::placeholder {
				color: rgba(0, 0, 0, 0.5);
			}
		}

		img {
			opacity: 1;
			filter: invert(100%);
		}
	}
`;

export { StyledContainer, StyledInput, StyledImage };
